<bee-item-list-featured [items]="genericContainers" [title]="containerType.name" (goTo)="goTo($event)" (tagSelect)="selectTag($event)"></bee-item-list-featured>